// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '지엘파마',
  targetSheetName: 'GLPA_2026년 6월 수수료',
  headerRowIndex: 7,
  headerRowCount: 1,
  dataStartRowIndex: 8,
  repeatedHeaderRowAction: 'skip',
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '약 가',
    commissionRate: '법인요율표 (%)',
    commissionNote: '기타 참고 사항',
  },
  requiredHeaders: [
    '구 분',
    '복지부분류',
    '대분류',
    '소분류',
    '성 분 · 함 량',
    '제품명',
    '허가권자',
    '대조약',
    '약 가',
    '보험코드',
    '포장단위',
    '법인요율표 (%)',
    '수수료 금액 (원)',
    '기타 참고 사항',
  ],
});
